import { motion } from 'framer-motion'
import styled from 'styled-components'

export const StoreSwitchPage = styled(motion.div)<{ upperGap: number }>`
  overflow-y: auto;
  height: calc(100dvh - ${({ upperGap }) => upperGap}px);
  position: fixed;
  top: ${({ upperGap }) => upperGap}px;
  left: 0;
  right: 0;
`
